export const FIND_NOTES_BY_PLAYER_COMPLETED = "project/notes/findNotesByPlayerCompleted";
export const FIND_NOTE_BY_ID_COMPLETED = "project/notes/findNoteByIdCompleted";
export const FIND_NOTES_BY_PLAYER_AND_DATES_COMPLETED = "project/notes/findNotesByPlayerAndDatesCompleted";
export const ADD_NOTE_TO_PLAYER_COMPLETED = "project/notes/addNoteToPlayerCompleted";
export const UPDATE_NOTE_COMPLETED = "project/notes/updateNoteCompleted";
export const REMOVE_NOTE_COMPLETED = "project/notes/removeNoteCompleted";